/** SELF CHECK-IN SERVICES * SELF CHECK-IN SERVICES * SELF CHECK-IN SERVICES */

// CREATE new Self Check-In
async function createNewSelfCheckIn(uId, token, today, checkIn) {
  // returns true if create is successful, or throws error.

  // API call
  const newSelfCheckIn = { ...checkIn };
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'selfcheckin': newSelfCheckIn}),
  });
  const responseData = await response.json();
  console.log('*** Self Check-In Services >> createNewSelfCheckIn() response ***', response, responseData);

  // "err handling"
  if (!response.ok) { 
    // console.log(responseData);
    throw new Error(response.message || 'Failed to create new Self Check-In');
  }

  return responseData;
}






// READ One Self Check-In
async function getOneSelfCheckIn(uId, token, today) {
  // returns a Self Check-In object, or null

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/selfcheckin.json?auth=${token}`);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || "Failed to get today's Self Check-In");
  }

  // return the data
  return response.json();
}






// UPDATE One Self Check-In
async function updateOneSelfCheckIn(uId, token, today, checkIn) {
  // returns true if update is successful, or throws error.

  // API call
  const updatedSelfCheckIn = { ...checkIn };
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'selfcheckin': updatedSelfCheckIn}),
  });
  const responseData = await response.json();

  if (!response.ok) {
    // console.log(responseData);
    throw new Error(response.message || 'Failed to update Self Check-In');
  }

  return responseData;

}


// DELETE One EOD Review/Preview - tbd



export { createNewSelfCheckIn, getOneSelfCheckIn, updateOneSelfCheckIn };
